import { IConfirmationModalProps } from "./ConfirmationModalTypes"

import { useUI } from "providers/UIProvider"
import { UI_INITIAL_STATE } from "providers/UIProvider/UIProviderConstants"

import { Container, Center, Flex } from "@chakra-ui/react"

import Modal from "components/UI/organisms/Modal"
import Button from "components/UI/atoms/Button"
import Icon from "components/UI/atoms/Icon"
import Heading from "components/UI/atoms/Heading"

const ConfirmationModal: React.FC<IConfirmationModalProps> = () => {
  const { modals, toggleModal, T } = useUI()

  const { title, handleSubmit, handleDeny, content } = modals.confirmationModal.data

  const handleDenyClick = () => {
    toggleModal("confirmationModal", false, UI_INITIAL_STATE.modals.confirmationModal.data)
    if (handleDeny) {
      handleDeny()
    }
  }

  return (
    <Modal
      isOpen={modals.confirmationModal.isOpened}
      onClose={handleDenyClick}
      styles={{
        bodyPadding: "30px 35px",
      }}
    >
      <Container padding={0}>
        <Center textAlign="center" mb="30px">
          <Heading title={`${title}?`} variant="bold" size="lg" />
        </Center>
        {content && (
          <Center mt="30px" mb="30px">
            {content}
          </Center>
        )}
        <Flex width="100%" justifyContent="center" gap="5%">
          <Button
            text={T("actions.confirm")}
            onClick={handleSubmit}
            variant="success"
            leftIcon={
              <Icon
                name="confirm"
                iconStyles={{ width: "30px", height: "30px" }}
              />
            }
            styles={{ width: "180px", height: "55px", fontSize: "m" }}
          />
          <Button
            text={T("actions.deny")}
            onClick={handleDenyClick}
            variant="error"
            leftIcon={
              <Icon
                name="close_rounded"
                iconStyles={{ width: "30px", height: "30px" }}
              />
            }
            styles={{ width: "180px", height: "55px", fontSize: "m" }}
          />
        </Flex>
      </Container>
    </Modal>
  )
}

export default ConfirmationModal
